/**
 * Created by Rumyantsev Daniil on 20.06.2018.
 */

import { Pipe, PipeTransform } from '@angular/core';
/*
 * Принимает дату в формате (+/-)hh:mm, пример: '+05:30'
 * Возвращает дату в мСек со смещением таймзоны
 *
 * Usage:
 *   dateInMillis | timezone
 */
@Pipe({name: 'timezone'})
export class TimezonePipe implements PipeTransform {

  readonly HOUR_TO_MILLIS = 60 * 60 * 1000;

  transform(dateToOffset: string): any {

    // console.log("Timezone pipe date before change:", dateToOffset);

    if(dateToOffset == null || dateToOffset == '') {
      return null;
    }

    let timezoneOffset = sessionStorage.getItem('timezone');
    // console.log("Timezone :", timezoneOffset);

    if(timezoneOffset.match(/^[+-]\d\d:\d\d$/) == null) {
      console.log('Not matching');
      return null;
    }

    /*
     * Эта замена нужна что бы при наличии + происходило добавление часов а не вычетание, как
     * происходит при создании даты
     */
    if(timezoneOffset.match(/\+/) != null) {
      timezoneOffset = timezoneOffset.replace('+', '-');
    } else {
      timezoneOffset = timezoneOffset.replace('-', '+');
    }

    // console.log('String timezone Result',  timezoneOffset);

    // Такое непонятное форматирование нужно что бы Safari мог нормально создать объект Date
    const date = new Date(dateToOffset.replace(/ /g, "T") + timezoneOffset);

    // const offsetResult = date.getTime();
    // const offsetResult = date.getTime() + timezoneOffset * this.HOUR_TO_MILLIS;

    // console.log("Timezone pipe after change:", date);
    return date.getTime();
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/timezone.pipe.ts